/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OverviewDetails {
    getFixupPrototypeFunction() { return OverviewDetails.fixupPrototype; }

    static newInstance(model: Partial<OverviewDetails>): OverviewDetails {
        let obj = Object.assign(new OverviewDetails(), model);
        OverviewDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OverviewDetails>): OverviewDetails {
        if (!model) return null;
        return OverviewDetails.newInstance(<OverviewDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OverviewDetails) {
        if (!obj) return;

        models.OverviewDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OverviewDetails): boolean {
        Object.setPrototypeOf(obj, OverviewDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.number_of_rIs === undefined) {
            this.number_of_rIs = 0;
        }
    }

    /**
     * Payment method which is monthly or yearly
     */
    payment_option: string;

    /**
     * Instance Flexibility Should be on
     */
    instance_flexibility: string;

    /**
     * Reservation Name
     */
    reservation_name: string;

    /**
     * Reservation Type
     */
    reservation_type: string;

    /**
     * Expiry date
     */
    expiry_date: string;

    /**
     * Reservation SKU details
     */
    reservation_sku: string;

    /**
     * Region where the resource is created
     */
    region: string;

    /**
     * Name of the cloud account
     */
    cloud_account_name: string;

    /**
     * Date of purchase
     */
    purchase_date: string;

    /**
     * How many RIs are present
     */
    number_of_rIs: number;

    /**
     * scope of the ri utilization
     */
    scope: string;

}
